import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
// @ts-ignore
import qs from "qs";
import Api from "./Api";
import { AlterarSenhaUsuarioDTO } from "./auth/AlterarSenhaUsuarioDTO";
import { AtualizarTokenDTO } from "./auth/AtualizarTokenDTO";
import { CadastroUsuarioPagedResultDTO } from './auth/CadastroUsuarioPagedResultDTO';
import { FiltroUsuariosDTO } from './auth/FiltroUsuariosDTO';
import { LoginDTO } from "./auth/LoginDTO";
import { LoginResponseDTO } from "./auth/LoginResponseDTO";
import { RequestResetSenhaDTO } from "./auth/RequestResetSenhaDTO";
import { UsuarioAdministrativoDTO } from "./auth/UsuarioAdministrativoDTO";
import { RetornoMensagemDTO } from './cadastro/saude/RetornoMensagemDTO';
import { authApiConfig } from "./config";
import { usuarioStorage } from "@/store/usuario/UsuarioStorage";

export class AuthApi extends Api {
  constructor(config: AxiosRequestConfig) {
    usuarioStorage.setEntrada("gs");
    if (config.auth) {     
      config.auth.username = config.auth.username + (config.auth as any).client_id,
      config.auth.password = usuarioStorage.getEntrada() as string;
    }

    super(config);
  }

  efetuarlogin(loginDTO: LoginDTO): Promise<LoginResponseDTO> {
    return this.post<LoginDTO>("/oauth/token", qs.stringify(loginDTO))
      .then((loginResponse: AxiosResponse) => {
        const { data } = loginResponse;
        return data;
      })
      .catch((error: AxiosError) => {
        console.log(error);
        throw new Error("Falha ao obter dados do usuário");
      });
  }

  atualizarToken(atualizarTokenDTO: AtualizarTokenDTO): Promise<LoginResponseDTO> {
    return this.post<AtualizarTokenDTO>("/oauth/token", qs.stringify(atualizarTokenDTO))
      .then((loginResponse: AxiosResponse) => {
        const { data } = loginResponse;
        return data;
      })
      .catch((error: AxiosError) => {
        console.log(error);
        throw new Error("Falha ao obter dados do usuário");
      });
  }

  resetarSenha(token: string, senha: string) {
    return this.post("/usuarios/alterarSenha", {
      token,
      senha,
    })
      .then((loginResponse: AxiosResponse) => {
        const { data } = loginResponse;
        return data;
      })
      .catch((error: AxiosError) => {
        // console.log(error);
        throw new Error("Falha ao redefinir a senha do usuário");
      });
  }

  solicitarResetSenha(req: RequestResetSenhaDTO) {
    return this.post<RequestResetSenhaDTO>("/usuarios/resetSenhaAdministrativo", req);
  }

  alterarSenha(alteracaoSenha: AlterarSenhaUsuarioDTO): Promise<void> {
    return this.post<AlterarSenhaUsuarioDTO>("/usuarios/alterarSenhaUsuario", alteracaoSenha)
      .then((alteraSenhaResponse: AxiosResponse) => {
        const { data } = alteraSenhaResponse;
        return data;
      })
      .catch((error: AxiosError) => {
        const data = error.response?.data;
        if (data?.detail?.indexOf("senha")) {
          throw new Error(data.detail);
        } else {
          throw new Error("Falha ao efetuar a alteração da senha");
        }
      });
  }

  salvarUsuario(usuarioAdministrativo: UsuarioAdministrativoDTO): Promise<RetornoMensagemDTO> {
    return this.post<UsuarioAdministrativoDTO>("/usuarios/administrativo", usuarioAdministrativo)
      .then((response: AxiosResponse) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        if(error.response?.data.status == 400 &&
          `${error.response?.data.detail}`.includes("existe")) {
            throw new Error(`${error.response?.data.detail}`);
        } else {
          throw new Error(error.response?.data?.detail || 'Falha ao salvar usuário.');
        }
      });
  }

  alterarUsuario(usuarioAdministrativo: UsuarioAdministrativoDTO): Promise<RetornoMensagemDTO> {
    return this.put<UsuarioAdministrativoDTO>(`/usuarios/administrativo/${usuarioAdministrativo.id}`, usuarioAdministrativo)
      .then((response: AxiosResponse) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error.response);
        if(`${error.response?.data.detail}`.includes("Impossível ") || `${error.response?.data.detail}`.includes("existe")) {
          throw new Error(error.response?.data.detail)  
        } else {
          throw new Error("Falha ao alterar usuário");
        }
      });
  }

  excluirUsuario(idUsuario: number): Promise<RetornoMensagemDTO> {
    return this.delete(`/usuarios/administrativo/${idUsuario}`)
    .then((response: AxiosResponse) => {
      const {data} = response;
      return data;
    })
    .catch((error: AxiosError) => {
      console.error(error.response);
      if(`${error.response?.data.detail}`.includes("Impossível ")) {
        throw new Error(error.response?.data.detail)  
      } else {
        throw new Error("Falha ao excluir o usuário.")
      }
    })
  }

  pesquisarUsuarios(filtroDTO: FiltroUsuariosDTO): Promise<CadastroUsuarioPagedResultDTO> {
    return this.get('/usuarios/pesquisar', { params: filtroDTO })
    .then((response: AxiosResponse) => {
      const { data } = response;
      return data;
    })
    .catch((error: AxiosError) => {
      console.error(error);
      throw new Error("Falha ao pesquisar usuarios");
    })
  }
  
  obterusuario(idUsuario: number): Promise<UsuarioAdministrativoDTO> {
    return this.get(`/usuarios/${idUsuario}`)
    .then((response: AxiosResponse) => {
      const { data } = response;
      return data;
    })
    .catch((error: AxiosError) => {
      console.error(error);
      throw new Error("Falha ao pesquisar usuarios");
    })
  }
}

export const authApi = new AuthApi(authApiConfig);
